import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n)

const messages = {
  en: {
    user_list: {
      meta: {
        title: 'User List'
      },
      title: 'Users',
      text: {
        all: 'All',
        username: 'Username',
        email: 'Email',
        phone: 'Phone',
        display_name: 'Display name',
        lock_user: 'Lock user',
        created_date: 'Created date',
        last_login_date: 'Last login date',
        create_user_successfully: 'Create user successfully.'
      },
      input: {
        label: {
          search_for_user: 'Search for user'
        }
      }
    },
    user_details: {
      meta: {
        title: 'User Details'
      },
      title: 'User details',
      sub_title: {
        profile: 'Profile',
        social_login: 'Social login',
        email: 'Email',
        phone: 'Mobile',
        events: 'Events',
        security: 'Security',
        devices: 'Logged in devices',
        metadata: 'Metadata'
      },
      text: {
        no_social_login: 'No social login',
        password: 'Password',
        '2_step_verification': '2FA',
        last_changed: 'Last changed {date}',
        last_used: 'Last used {date}',
        account_created: 'Account created {date}',
        app_metadata: 'App metadata',
        user_metadata: 'User metadata',
        system_metadata: 'System metadata'
      }
    },
    user_details_profile: {
      meta: {
        title: 'Profile - User Details'
      }
    },
    user_details_social_login: {
      meta: {
        title: 'Social login - User Details'
      },
      title: 'Social login',
      back_title: 'User details',
      table: {
        header: {
          social_platform: 'Social platform',
          id: 'Social platform User ID',
          associated_at: 'Associated at',
          last_used: 'Last used',
          actions: 'Actions'
        }
      },
      button: {
        disconnect: 'Disconnect'
      },
      text: {
        no_social_login: 'No social login',
        disconnect_social_login: 'Disconnect social login',
        disconnect: 'Once {service} login is disconnected, user can no longer use {service} to login.',
        disconnect_success: 'Social login disconnected',
        disconnect_failed: 'This social login cannot be disconnected, at least one login method is needed for the user to access the account.'
      }
    },
    user_details_contact: {
      meta: {
        title: 'Contact - User Details'
      }
    },
    user_details_logs: {
      meta: {
        title: 'Logs - User Details'
      }
    },
    user_details_security: {
      meta: {
        title: 'Security - User Details'
      },
      title: 'Security',
      back_title: 'User details',
      sub_title: {
        change_password: 'Change password',
        '2_step_verification': '2-step verification'
      },
      table: {
        header: {
          mfa: 'MFA',
          description: 'Description',
          last_used: 'Last used'
        }
      },
      button: {
        change_password: 'Change password'
      },
      text: {
        password: 'Password',
        '2_step_verification': '2-step verification',
        sms: 'SMS',
        totp: 'Authenticator App',
        backup_code: 'Backup code',
        since: 'Since {date}',
        last_changed: 'Last changed {date}'
      }
    },
    user_details_devices: {
      meta: {
        title: 'Devices - User Details'
      }
    },
    user_details_metadata: {
      meta: {
        title: 'Metadata - User Details'
      }
    },
    user_create: {
      meta: {
        title: 'Create new user'
      },
      title: 'Create user',
      text: {
        back_title: 'Users',
        profile: 'Profile',
        generate_password: 'Generate password'
      },
      input: {
        label: {
          username: 'Username',
          password: 'Password',
          confirm_password: 'Confirm password',
          email: 'Email',
          phone: 'Phone',
          email_or_mobile: 'Email or mobile',
          name: 'Name'
        },
        error: {
          invalid_username: 'Invalid username',
          duplicate_username: 'Duplicate username',
          invalid_email: 'Invalid email',
          invalid_phone: 'Invalid phone',
          invalid_contact: 'Invalid contact',
          duplicate_contact: 'Duplicate contact'
        }
      },
      button: {
        create_user: 'Create user',
        generate: 'Generate',
        copy: 'Copy'
      }
    },
    log_list: {
      meta: {
        title: 'Log List'
      }
    },
    role_list: {
      meta: {
        title: 'Role List'
      },
      title: 'Roles',
      modal: {
        title: {
          create_role: 'Create role',
          delete_role: 'Delete role'
        },
        text: {
          delete_role: 'Are you sure you want to remove {role}?'
        },
        button: {
          create_role: 'Create role',
          delete_role: 'Delete role'
        }
      },
      text: {
        create_role_successfully: 'Create role successfully',
        delete_role_successfully: 'Delete role successfully'
      }
    },
    role_details: {
      meta: {
        title: 'Role Details'
      },
      title: 'Role Details',
      text: {
        back_title: 'Roles',
        permissions: 'Permissions for {role}'
      }
    },
    email_template_settings: {
      meta: {
        title: 'Email Template Settings'
      }
    },
    sms_template_settings: {
      meta: {
        title: 'SMS Template Settings'
      }
    },
    profile: {
      meta: {
        title: 'Profile'
      }
    },
    settings: {
      meta: {
        title: 'Settings'
      }
    },
    email_settings: {
      title: 'Email settings',
      modal: {
        title: 'Edit {name} email',
        text: {
          success_create: 'Template updated successfully',
          success_restore_to_default: 'Template restored to default successfully',
          restore_to_default: 'Restore to default',
          restore_to_default_description: 'Are you sure to restore template to default?'
        },
        input: {
          label: {
            subject: 'Subject',
            text_template: 'Text template',
            html_template: 'HTML template'
          }
        },
        button: {
          save: 'Save',
          restore_to_default: 'Restore to default',
          confirm: 'Confirm'
        }
      },
      text: {
        default: 'Default',
        last_edited_on: 'Last edited on {date}',
        edit: 'Edit',
        verification_mail: 'Verification',
        reset_password_authentication_mail: 'Reset password'
      },
      input: {
        label: {
          language: 'Language'
        }
      }
    },
    sms_settings: {
      title: 'SMS settings',
      modal: {
        title: 'Edit {name} SMS',
        text: {
          success_create: 'Template updated successfully',
          success_restore_to_default: 'Template restored to default successfully',
          restore_to_default: 'Restore to default',
          restore_to_default_description: 'Are you sure to restore template to default?'
        },
        input: {
          label: {
            subject: 'Subject',
            text_template: 'Text template'
          }
        },
        button: {
          save: 'Save',
          restore_to_default: 'Restore to default',
          confirm: 'Confirm'
        }
      },
      text: {
        default: 'Default',
        last_edited_on: 'Last edited on {date}',
        edit: 'Edit',
        authentication_sms: 'Authentication',
        verification_sms: 'Verification',
        reset_password_authentication_sms: 'Reset password'
      },
      input: {
        label: {
          language: 'Language'
        }
      }
    },
    general: {
      blank: '\xa0',
      management: 'Management',
      settings: 'Settings',
      register: 'Register',
      sign_in: 'Sign In',
      sign_out: 'Sign out',
      back: 'Back',
      username: 'Username',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      password: 'Password',
      mfa: 'MFA',
      sms: 'SMS',
      authenticator: 'Google authenticator',
      enabled: 'Enabled',
      disabled: 'Disabled',
      on: 'ON',
      off: 'OFF',
      locked: 'Locked',
      app_metadata: 'App metadata',
      user_metadata: 'User metadata',
      system_metadata: 'System metadata',
      permanently: 'Permanently',
      primary: 'Primary',
      system: 'System',
      role: 'role',
      user_list: 'user list',
      log_list: 'log list',
      roles_list: 'roles list',
      create_user: 'create users'
    },
    title: {
      users: 'Users',
      create_user: 'Create User',
      roles: 'Roles',
      user_details: 'User details',
      profile: 'Profile',
      email: 'Email',
      phone: 'Mobile',
      edit_profile: 'Edit profile',
      contact: 'Contact',
      logs: 'Event logs',
      security: 'Security',
      devices: 'Logged in Devices',
      metadata: 'Metadata',
      verification: 'Verification',
      actions: 'Actions',
      assign_role: 'Assign role',
      delete_role: 'Delete {role}',
      change_password: 'Change password',
      email_settings: 'Email settings',
      sms_settings: 'SMS settings'
    },
    input: {
      username: 'Username',
      password: 'Password',
      confirm_password: 'Confirm password',
      email: 'Email',
      phone: 'Phone',
      name: 'Name',
      role_name: 'Role name'
    },
    description: {
      last_changed: 'Last changed: {date}',
      last_active: 'Last active: {date}',
      last_updated: 'Last updated: {date}',
      user_metadata: 'Data that the user has read/write access to (e.g. color_preference, blog_url, etc.)',
      app_metadata: 'Data that the user has read-only access to (e.g. roles, permissions, vip, etc.)',
      new_role_assign: 'New role assign to {username}',
      lock_user: 'If {username} is locked, he/she will not be able to login to the account',
      unlock_user: 'Unlock {username} to resume login for the user',
      add_contact: 'Add new {contact} for {username}',
      delete_contact: 'Delete the following {contact}:',
      update_primary_contact: 'Set the following {contact} as primary contact',
      change_password: 'Change the password for {username}',
      total_items: '{number} items',
      total_users: '{count} user | {count} users',
      no_contact: 'No {contact} added',
      log_out_device: 'The following device will be logged out:',
      role_details: 'Role Details for {role}',
      work_in_progress: 'Work in progress'
    },
    actions: {
      assign_role: 'Assign role',
      change_password: 'Change password',
      disable_mfa: 'Disable MFA',
      create_user: 'Create user',
      lock_user: 'Lock user',
      unlock_user: 'Unlock user',
      delete_user: 'Delete user',
      add_contact: 'Add {contact}',
      delete_contact: 'Delete {contact}',
      resend_verification: 'Resend verification',
      update_primary_contact: 'Set as primary',
      disable_all: 'Disable all',
      log_out: 'Log out',
      log_out_device: 'Log out device'
    },
    button: {
      create: 'Create',
      create_user: 'Create user',
      delete: 'Delete',
      save: 'Save',
      log_out: 'Log out',
      log_out_all: 'Log out all devices',
      ok: 'OK'
    },
    verification: {
      verified: 'Verified',
      non_verified: 'Non-verified'
    },
    table_header: {
      mfa: 'MFA',
      name: 'Name',
      last_used: 'Last used',

      user_agent: 'User agent',
      last_active: 'Last active',
      log_out_device: 'Log out device'
    },
    status: {
      success: {
        update_profile: 'Profile is updated',
        resend_verification: 'Resend verification success',
        update_metadata: 'Update metadata success',
        log_out: 'Log out success.'
      },
      error: {
        general: 'Error: {message}',
        creating: 'Error when creating: {message}',
        action: 'Alert error: {message}',
        not_log_in: 'You are not signed in.',
        not_authorized: 'You are not authorized to view the {page}.',
        user_metadata: 'User metadata syntax error',
        app_metadata: 'App metadata syntax error'
      },
      info: {
        loading: 'Loading for create...'
      }
    },
    'authcore.user.register': 'Register user',
    languages: {
      en: 'English',
      'zh-hk': '繁體中文（香港）'
    }
  },
  zh: {
  }
}

export default new VueI18n({
  /**
   * TODO: Allow users to pick a locale & refactor the location of messages
   * https://gitlab.com/blocksq/kitty/issues/161
   */
  locale: 'en',
  messages
})
